// URL Configuration
export const SITE_URLS = {
  development: 'http://localhost:3000',
  railway: 'https://scraper-production-e20b.up.railway.app',
  production: 'https://app.solem.ai'
} as const;

export const SITE_URL = (() => {
  // Get the current origin, falling back to production URL if not available
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : SITE_URLS.production;

  // Determine the environment based on the current origin
  if (currentOrigin.includes('localhost')) {
    return SITE_URLS.development;
  } else if (currentOrigin.includes('railway.app')) {
    return SITE_URLS.railway;
  } else if (currentOrigin.includes('solem.ai')) {
    return SITE_URLS.production;
  }

  // Default to the current origin if none of the above match
  return currentOrigin;
})();

// Supabase configuration
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Auth configuration
export const AUTH_CALLBACK_URL = `${SITE_URL}/auth/callback`;

// Function to get auth config based on current environment
export function getAuthConfig() {
  return {
    redirectTo: AUTH_CALLBACK_URL,
    providers: ['google'],
    queryParams: {
      access_type: 'offline',
      prompt: 'consent',
      redirect_uri: AUTH_CALLBACK_URL
    }
  };
} 